<template>
  <v-autocomplete
    v-model="clifor"
    :loading="loading"
    :items="items"
    :search-input.sync="searchClifor"
    cache-items
    no-data-text="Cerca un nominativo per codice o descrizione"
    :label="item.label"
    :rules="rulesValidation"
    item-text="testo"
    item-value="id"
    clearable
    :return-object="true"
    :disabled="disabled || localDisabled"
    @change="onchange"
     v-if="showItem"
  >
    <template v-slot:prepend>
      <v-icon v-if="!item.addForbidden && clifor" color="info" @click="onModificaClifor" title="Modifica cliente/fornitore">mdi-pencil</v-icon>        
    </template>    
    <template v-slot:append-outer>
      <v-icon v-if="!item.addForbidden" color="success" @click="onNuovoClifor" title="Crea un nuovo cliente/fornitore">mdi-account-plus-outline</v-icon>
    </template>
  </v-autocomplete>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  import clienti from '@/services/clientiService.js'

  export default {
    name: 'clifor',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: Number
    },
    data (vm) {
      return {
      loading: false,
      items: [],
      debounceSearch: null,
      searchClifor: '',
      clifor: '',
      selectFirst: true,
      newItem: null,
      primaChiamata: false
      }
    },
    created() {
      this.debounceSearch = _.debounce(this.searchCliforDeb, 500)
    },
    async mounted() {
      if (this.item && this.item.value) {
        // await this.querySelections(this.item.value.codice)
        // this.clifor = Object.assign({}, this.items[0])
        const cliente = await this.queryCodiceCliente(this.item.value.codice)
        this.items = [cliente]
        this.clifor = cliente
        this.primaChiamata = true
      }
    },
    watch: {
      async searchClifor(val) {
        if (val && !this.primaChiamata) {
          await this.debounceSearch(val)
        }
        this.primaChiamata = false
      }
/*       async item(info) {
        if (info.value) {
          await this.searchCliforDeb(info.value.codice)
          this.$forceUpdate()
        }
      } */
    },
    computed: {
      showItem() {
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      },
      localDisabled() {
        if (!this.item || !this.appoggio) {
          return true
        }
        const cl = this.item.model === 'anagrafica.cliente'
        const fr = this.item.model === 'anagrafica.fornitore'
        const vc = this.appoggio.clienteVisibile
        const vf = this.appoggio.fornitoreVisibile
        return cl && vf || fr && vc || (!cl && !fr)
      }      
    },
    methods: {
      async searchCliforDeb(val) {
        // TODO: verificare se quello cercato è già presente prima di richiamare
        // const pr = this.prodottiSelezionati.filter(x => x === val)
        // if (val && pr.length === 0) {
        if (val) {
          await this.querySelections(val)
        }
      },
      async querySelections (val) {
        this.loading = true
        const filtri = {
          testo: val,
          isCliente: this.appoggio.clienteVisibile,
          isFornitore: this.appoggio.fornitoreVisibile
        }
        const data = await clienti.getFilteredCustomers(filtri, null, 'v3')
        const cp = data && data.total_rows > 0 ? data.rows : []
        this.items = cp.map(x => {
          return { 
            testo: `${x.codice} - ${x.ragioneSociale} ${x.amministrativi && x.amministrativi.partitaIva || ''}`,
            id: x._id,
            codice: x.codice,
            descrizione: x.ragioneSociale,
            cliente: x.amministrativi.cliente,
            fornitore: x.amministrativi.fornitore     }
        })
        this.loading = false
      },
      async queryCodiceCliente(codice) {
        this.loading = true
        const cliente = await clienti.getCliente(codice)
        this.loading = false 
        return { 
          testo: `${cliente.codice} - ${cliente.ragioneSociale} ${cliente.amministrativi && cliente.amministrativi.partitaIva || ''}`,
          id: cliente._id,
          codice: cliente.codice,
          descrizione: cliente.ragioneSociale,
          cliente: cliente.amministrativi.cliente,
          fornitore: cliente.amministrativi.fornitore
        }
      },
      onchange(value) {
        if (value) {
          this.searchClifor = ''
          const clifor = {
            codice: this.clifor.codice, //this.item.value.codice || this.item.value.id,
            descrizione: this.clifor.descrizione // this.item.value.descrizione
          }
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: clifor, item: this.item.value })
        }
      },
      async onNuovoClifor() {
        this.newItem = await clienti.getModello()
        this.$store.commit('clienti/SET_CLIENTE', this.newItem)
        this.$store.commit('clienti/SET_CREA_CLIFOR')
      },
      async onModificaClifor() {
        const clifor = await clienti.getCliente(this.item.value.codice)
        this.$store.commit('clienti/SET_CLIENTE', clifor)
        this.$store.commit('clienti/SET_EDIT_CLIFOR')
      }
    }
  }
</script>
